const styles = {
  root: {
    '& iframe': {
      paddingTop: { xs: 2, lg: 6 },
      minHeight: { xs: '1100px', lg: '1250px' },
      width: '100%',
    },
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100%',
  },
}

export default styles
